// extracted by mini-css-extract-plugin
export default {"techGallery":"techGallery_techGallery__uDo8D"};